import { section } from "@/neon";

import carousel from "@/components/carousel";

section("product-recommendations", {
  onLoad() {
    this._getProductRecommendations();
  },

  _getProductRecommendations() {
    const { sectionId, productId, limit } = this.container.dataset;

    // Build request URL
    var requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();

    request.open("GET", requestUrl, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        this.container.innerHTML = container.querySelector(
          ".product-recommendations"
        ).innerHTML;

        this._initSlider();
      }
    };
    request.send();
  },

  _initSlider() {
    this.carousel = carousel(this.container);
  },

  onUnload() {
    this.carousel.unload();
  },
});
